const isValuesEmpty = (o: { [key: string]: any }) =>
  Object.keys(o).every((key: string) => !o[key]);

export default isValuesEmpty;
